module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portal"
  }, [_c('menu-left', {
    attrs: {
      "logged-in": _vm.userAuth.loggedIn
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "full-container"
  }, [_c('router-view'), _vm._v(" "), _vm._m(0)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "powered-by-footer"
  }, [_c('small', [_vm._v("\r\n        Powered by "), _c('a', {
    attrs: {
      "href": "http://travelplugin.nl",
      "target": "_BLANK"
    }
  }, [_vm._v("Travelplugin")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b6a9ab10"}!./src/templates/portal.html
// module id = 549
// module chunks = 1